<template>
  <div>
      <form action="" id="mainForm" v-on:submit.prevent="submitForm">
        <div class="order-form-info" style="margin-bottom: 30px;">
            <div class="form-container">
                <div>Fill the Form <span></span></div>
                <div>Submit <span></span></div>
                <div>Download Invoice <span></span></div>
                <div>Pay <span></span></div>
                <div>Track Progress <span></span></div>
            </div>
        </div>
        <h3>Personal information</h3>
        <div class="form-inner-holder">
          <div class="form-inner-wrapper">
              <label>First Name <span class="necessarily">*</span> <input type="text" id="firstname" name="First Name" v-model="formData['First Name']" required placeholder="John"></label><br />
              <label>Last Name <span class="necessarily">*</span> <input onkeyup="checkParams()" type="text" id="lastname" name="Last Name" v-model="formData['Last Name']" required placeholder=" Smith"></label><br />
              <label>Email: <span class="necessarily">*</span> <input onkeyup="checkParams()" type="email" id="email" name="EMail" v-model="formData.EMail" required placeholder="treto@gmail.com"></label><br />
              <label>ASIN: <span class="necessarily">*</span> <input onkeyup="checkParams()" type="text" id="asin" name="ASIN" v-model="formData.ASIN" required placeholder="1251515"></label><br />
              <label>Campaign name: <span class="necessarily">*</span> <input onkeyup="checkParams()" type="text" id="campaignname" name="Campaign name" v-model="formData['Campaign name']" required placeholder=""></label><br />
          </div>
          <div class="form-inner-wrapper">
              <label>Company name: <input required type="text" minlength=2 name="Company name" placeholder="Company name" v-model="formData['Company name']"></label><br />
              <label>Address: <input type="text" name="Address" placeholder="Some address" v-model="formData.Address"></label><br />
              <label>City: <input type="text" name="City" placeholder="Some city" v-model="formData.City"></label><br />
              <label>Zip: <input type="text" name="Zip" placeholder="12345" v-model="formData.Zip"></label><br />
              <label>Country: <country-select v-model="formData.Country" :country="formData.Country" required/></label><br/>
          </div>
        </div>
        <h3>VAT info<br><span class="sub">If you don’t have EU VAT number, the 23% of VAT will be added to your invoice amount.</span></h3>
        
        <div class="form-inner-holder">
          <div class="form-inner-wrapper">
            <label>Tax Type:
              <select name="VAT type" v-model="formData.Tax.Type" v-on:change="formData.Tax.Number=''">
                <option :value="null">None</option>
                <option v-for="option in get_taxes(formData.Country)" :key="option.id" :value="option.title">{{option.title}}</option>
              </select>
            </label>
          </div>
          <div class="form-inner-wrapper">
            <label >Tax number: <input type="text" name="Tax number" placeholder="1234567890" v-model="formData.Tax.Number" :disabled="!formData.Tax.Type"></label>
          </div>
        </div>
        <h3>Order details</h3>
        <fieldset class="choises-box" data-form-elem="country-selector">
            <legend>Choose country</legend>
            <div class="choises">
                <label class="choise" v-for="country in countries" :key="country.id">{{country.title}} <input type="checkbox" :change="calculate()" name="country" :value="country" v-model="formData.Countries"/><span></span></label>
            </div>               
        </fieldset>
        <div class="choises-fieldsets">
            <fieldset v-for="country in formData.Countries" :key="country.id"  class="form__country-block" data-form-elem="country-block" :data-country="country">
                <legend>{{country.title}}</legend>
                <label>Link <span class="necessarily">*</span>
                    <input type="text" v-model="country.link" :data-country="country" required>
                    <span class="tooltips"
                        tooltip="Put here the link to the product page on Amazon. You can use Super-URLs like 2-Step or Filter-URL if you want"
                        tooltip-position="top"><span>Put here the link to the product page on Amazon. You can use Super-URLs like 2-Step or Filter-URL if you want</span></span></label>
                <br>
                <label>Keyword <span class="necessarily">*</span>
                    <input type="text" v-model="country.keyword" required>
                    <span class="tooltips"
                        tooltip="Put here the keyword you want to rank for - our testers will search manually for it"
                        tooltip-position="top"><span>Put here the keyword you want to rank for - our testers will search manually for it</span></span></label>
                <br>
                <label>Page <span class="necessarily">*</span>
                    <input  type="text" name="uk_page" v-model="country.page" required>
                    <span class="tooltips"
                        tooltip="Put here the page number for the keyword you’ve mentioned in the previous step to help testers to find your product"
                        tooltip-position="top"><span>Put here the page number for the keyword you’ve mentioned in the previous step to help testers to find your product"</span></span></label>
                <br>
                <label>Price <span class="necessarily">*</span>
                    <input  type="number" step="0.01" value=0.00 :change="calculate()" v-model.number="country.priceLocal" title="This should be a number with up to 2 decimal places." required>
                    <span class="tooltips"
                        tooltip="Put here product price on Amazon testers will pay for your product. You agree not to change the price until the campaign ends!"
                        tooltip-position="top"><span>Put here product price on Amazon testers will pay for your product. You agree not to change the price until the campaign ends!</span></span></label>
                <br>
                <label>Quantity <span class="necessarily">*</span>
                    <input  type="number" data-form-elem="reviews" value=0 :change="calculate()" v-model.number="country.quantity" required><span
                        class="tooltips"
                        tooltip="Put here the number of reviews you want to buy for this particular market."
                        tooltip-position="top"> <span>Put here the number of reviews you want to buy for this particular market.</span></span></label>
                <br>
            </fieldset>
        </div>
        <div class="form__total">Total €, excl. VAT: <span id="total">{{formData.Total}}</span></div>
        <div class="form-info-checkboxes">
            <p>We collect your information for communication with you regarding order related cases.&nbsp;Please, check our <a href="#ex1" rel="modal:open">Privacy Policy</a> to know how we use your data.</p>
            <label>
                <input type="checkbox" required id="checkedForm" name="terms" value="terms" v-model="formData.Terms"><span></span>
                <p>I agree with your <a href="#ex2" rel="modal:open">Terms of Service</a> and consent to my information being stored for the above purpose.</p>
            </label>
            <label>
                <input type="checkbox" name="mailing" value="mailing"><span></span>
                <p>I would like to receive promotional emails from time to time. All emails include an unsubscribe links. <span>(Optional)</span></p>
            </label>
        </div>
        <div class="submit-box">
          <div class="loader-box">
            <div id="loader" :class="'lds-roller ' + (!state.submitting ? 'lds-roller_hidden' : '')">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <input id="submit" type="submit" value="SUBMIT" :disabled="submitEnabled()">
        </div>
    </form>
    <div id="form-result" :class="state.showSuccess ? 'success' : ''">
      <div class="bg" @click="state.showSuccess=false;"></div>
      <div class="modalSuccess">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.933899 21.6357C0.933899 9.77553 10.5934 0.116013 22.4536 0.116013C34.3138 0.116013 43.9733 9.77553 43.9733 21.6357C43.9733 33.4959 34.3138 43.1555 22.4536 43.1555C10.5934 43.1555 0.933899 33.4959 0.933899 21.6357ZM39.913 21.6357C39.913 11.9703 32.1188 4.17634 22.4536 4.17634C12.7882 4.17634 4.99422 11.9703 4.99422 21.6357C4.99422 31.3012 12.7882 39.0951 22.4536 39.0951C32.1191 39.0951 39.913 31.3012 39.913 21.6357ZM30.7644 13.7147C31.1293 13.3372 31.6304 13.1152 32.1602 13.0993L32.1604 13.1021C32.9946 13.0767 33.7623 13.5684 34.0891 14.3392C34.4126 15.1101 34.235 16.0014 33.6323 16.5851L20.6392 29.5781C19.8494 30.3712 18.5615 30.3712 17.7717 29.5781L11.2751 23.0816C10.8786 22.7042 10.6566 22.1839 10.6502 21.6383C10.6439 21.0927 10.8596 20.5661 11.2434 20.1823C11.6305 19.7953 12.1539 19.5828 12.6995 19.5859C13.245 19.5923 13.7653 19.8175 14.1427 20.2108L19.2055 25.2704L30.7644 13.7147Z" fill="#06B10D"/>
        </svg>                   
        <p>Wow! Thanks for the submitted order form!
        Please, check your mail inbox (or spam) folder for confirmation and invoice.</p>
        <a class="btnMcl" @click="state.showSuccess=false;">OK</a>
      </div>                
    </div>
  </div>
</template>
<script>

import axios from "axios";
import { Config } from "./config";
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)


export default {
  data: function() {
    return {
      countries: [
        { title: "United Kingdom", id: "uk", price: 0.00, priceLocal: 0.00, quantity: 0, currency:"GBP"},
        { title: "Germany", id: "de", price: 0.00, priceLocal: 0.00, quantity: 0, currency:"EUR"},
        { title: "France", id: "fr", price: 0.00, priceLocal: 0.00, quantity: 0, currency:"EUR"},
        { title: "Italy", id: "it", price: 0.00, priceLocal: 0.00, quantity: 0, currency:"EUR"},
        { title: "Spain", id: "es", price: 0.00, priceLocal: 0.00, quantity: 0, currency:"EUR"},
      ],
      taxes: [
        {id: 0, title: 'NIP Poland', rate: 0.23, countries: {include: ['PL'], exclude: []}},
        {id: 1, title: 'EU VAT', rate: 0, countries: {include: [], exclude: ['PL']}}
      ],
      state: {
        showSuccess: false,
        submitting: false},
      formData: {
        "First Name": "",
        "Last Name": "",
        EMail: "",
        ASIN: "",
        "Campaign name": "",
        "Company name": "",
        Address: "",
        City: "Kyiv",
        "Region/State": "",
        Zip: "",
        Country: '',
        Countries: [],
        Total: 0,
        Tax: {
          Type: null,
          Number: null
        }
      }
    };
  },
  name: "Form",
  props: {
    HTTP: Function,
    Config: Object
  },
  methods: {
    submitForm() {    
      this.state.submitting = true;
      var vm = this;
      var HTTP = this.getHTTP(Config.apiURL);
      HTTP.post("", this.formData).then(function(response){
        vm.state.submitting = false;
        vm.state.showSuccess = true;
        console.log('Submitted')// eslint-disable-line no-console
        console.log(response) // eslint-disable-line no-console
        }); 
    },
    getCheckedCountryCodes() {
      return this.formData["Coutry Codes"];
    },
    getHTTP(apiURL) {
      return axios.create({
        baseURL: apiURL
      });
    },
    submitEnabled() {
      return !this.formData.Terms;
    },
    calculate() {
        let sum = 0;
        for (const country in this.formData.Countries){
            let priceLocal = this.formData.Countries[country].priceLocal;
            let currency = this.formData.Countries[country].currency;
            let quantity = this.formData.Countries[country].quantity;

            let price = Math.round(priceLocal * Config.EXCHANGE[currency] * 100) / 100;
            this.formData.Countries[country].price = price;
            sum += (price + Config.BASE_PRICE) * quantity;
        }
        this.formData.Total = Math.round(sum * 100) / 100;
    },
    get_taxes(country){
      var taxes = [];
      this.taxes.forEach(function(tax){
        if (tax.countries.include.length){
          if (tax.countries.include.includes(country)){
           taxes.push(tax)
          }
        } else {
          if (!tax.countries.exclude.includes(country)){
             taxes.push(tax)
          }
        }
      });

      return taxes;
      // return this.taxes;
    }
  }
};
</script>
